import { render, staticRenderFns } from "./InventoryBalances.vue?vue&type=template&id=ef334c50&scoped=true"
import script from "./InventoryBalances.vue?vue&type=script&lang=js"
export * from "./InventoryBalances.vue?vue&type=script&lang=js"
import style0 from "./InventoryBalances.vue?vue&type=style&index=0&id=ef334c50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef334c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef334c50')) {
      api.createRecord('ef334c50', component.options)
    } else {
      api.reload('ef334c50', component.options)
    }
    module.hot.accept("./InventoryBalances.vue?vue&type=template&id=ef334c50&scoped=true", function () {
      api.rerender('ef334c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/InventoryBalances.vue"
export default component.exports